import { render, staticRenderFns } from "./tick-correct.vue?vue&type=template&id=50da1d8d&"
import script from "./tick-correct.vue?vue&type=script&lang=js&"
export * from "./tick-correct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports